import React from 'react';
import styled from '@emotion/styled';

interface AvatarProps {
  imageUrl?: string;
  fullName?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeVariants = {
  sm: '40px',
  md: '80px',
  lg: '160px',
};

const StyledAvatar = styled.div<{ size: 'sm' | 'md' | 'lg' }>`
  width: ${({ size }) => sizeVariants[size]};
  height: ${({ size }) => sizeVariants[size]};
  border-radius: 50%;
  border: 1px solid var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Poppins;
  font-size: ${({ size }) => (size === 'lg' ? '36px' : size === 'md' ? '20px' : '12px')};
  font-weight: 600;
  line-height: 1;
  background-color: var(--prim4);
  color: var(--white);
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`;

const Avatar: React.FC<AvatarProps> = ({ imageUrl, fullName, size = 'md' }) => {
  const getInitials = (name: string) => {
    const names = name.split(' ');
    const initials = names
      .map(n => n[0].toUpperCase())
      .join('')
      .slice(0, 2);
    return initials;
  };

  return (
    <StyledAvatar size={size}>
      {imageUrl ? <img src={imageUrl} alt="Avatar" /> : fullName ? getInitials(fullName) : 'U'}
    </StyledAvatar>
  );
};

export default Avatar;
